module.exports = __webpack_public_path__ + "img/title-icon.926d3ce2.svg";